<template>
  <div id="app">
    <router-view @modalOpen="modalOpen" @modalClose="modalClose"/>
    <div v-if="moving" class="loading-move d-flex align-items-center justify-content-center">
      <moon-loader :color="'#1E4573'" :size="'75px'"></moon-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    moving () {
      return this.$store.getters.moving
    }
  },
  methods: {
    modalOpen () {
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.width = '100vw'
      document.body.style.position = 'fixed'
      document.body.className = 'modal-open'
    },
    modalClose () {
      document.querySelector('.modal-open').classList.remove('modal-open')
      const top = document.body.style.top
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
      window.scrollTo(0, parseInt(top || '0') * -1)
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #F6F8F9;
  font-size: 14px;
}

.loading-move {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 2000;
}

*:focus {
  outline: none !important;
  box-shadow: none !important;
}

.fs-40 {
  font-size: 40px !important;
}

.fs-30 {
  font-size: 30px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-10 {
  font-size: 10px !important;
}

.fw-n {
  font-weight: normal;
}

.navbar-nav .dropdown-menu {
  position: absolute !important;
  background-color: #4A4A4A !important;
  max-height: 300px !important;
  overflow: auto !important;
}

.navbar .dropdown-item {
  padding: 0.5rem 1.5rem 0.5rem 0.5rem !important;
}

.navbar .dropdown-item.active,
.navbar .dropdown-item:active {
  background-color: #4A4A4A !important;
}

.navbar .dropdown-item:focus,
.navbar .dropdown-item:hover {
  background-color: rgba(0,0,0,0.3) !important;
}

.flexbox {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: flex-start;
}

.space-between {
  justify-content: space-between !important;
}

.sub-header {
  height: 48px;
  background-color: #ffffff;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: flex-start;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.sub-header a {
  color: #2c3e50;
}

.icon {
  color: #4A90E2;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 20px;
}

.chevron {
  color: #9b9b9b;
  font-size: 14px;
}

.text {
  font-size: 16px;
}

.sb {
  max-width: 240px;
  min-width: 240px;
  background-color: #ffffff;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 75px - 48px);
}

.mg-l-10 {
  margin-left: 10px;
}

.mg-r-10 {
  margin-right: 10px;
}

.a-btn {
  padding: 8px 50px !important;
  border-radius: 50px !important;
  font-weight: 700 !important;
  background-color: #4A90E2 !important;
  border: 1px solid #4A90E2 !important;
  box-shadow: 0 4px 12px rgba(0,0,0,.15) !important;
  white-space: nowrap;
}

.a-btn:hover {
  background-color: #3970B0 !important;
  border: 1px solid #3970B0 !important;
}

.m-btn {
  padding: 8px 50px !important;
  border-radius: 50px !important;
  font-weight: 700 !important;
  background-color: #6c757d !important;
  border: 1px solid #6c757d !important;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  white-space: nowrap;
  height: 40px;
}

.m-btn:hover {
  background-color: #5a6268 !important;
  border: 1px solid #545b62 !important;
}

.m-alert {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.m-alert:hover {
  background-color: #c82333 !important;
  border-color: #bd2130 !important;
}

.m-prize {
  background-color: #F5A623 !important;
  border-color: #F5A623 !important;
}

.m-prize:hover {
  background-color: #E69B21 !important;
  border-color: #E69B21 !important;
}

.m-grade {
  background-color: #E06171 !important;
  border-color: #E06171 !important;
}

.m-grade:hover {
  background-color: #C95766 !important;
  border-color: #C95766 !important;
}

.m-body {
  padding: 40px 0;
}

.hl-red {
  color: #FF0040;
}

.t-w {
  color: #ffffff;
}

.tab-title {
  color: #2c3e50;
  font-size: 16px;
  font-weight: bold;
  height: 40px;
}

.tab-active {
  color: #4A90E2;
}

.editor-content {
  font-size: 16px;
}

.editor-content h1 {
  font-size: 20px;
  font-weight: bold;
  color: #4A90E2;
  padding-bottom: 10px;
  border-bottom: 1px solid #4A90E2;
  margin: 24px 0 16px;
}

.editor-content p {
  margin: 0;
  line-height: 1.8;
}

.is-active {
  background: rgba(0,0,0,0.03);
  /* color: #ffffff; */
}

.editor-content .btn {
  /* background: #4b4b4b; */
}

.fc-g {
  color: grey;
  font-weight: normal;
}

.loading {
  height: 50vh;
  justify-content: center;
}

.dropzone .dz-preview {
  display: -webkit-flex;
  display: flex !important;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fafafa!important;
}

.dropzone .dz-preview .dz-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dz-cover .dz-preview {
  margin: 30px 0 !important;
}

.dz-avatar .dz-message {
  margin: 0 !important;
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dz-page .dz-preview,
.dz-avatar .dz-preview {
  margin: 25px 0 !important;
}

.dz-cover .dz-preview .dz-image {
  width: 760px!important;
  height: 400px!important;
  border-radius: 0!important;
}

.dz-avatar .dz-preview .dz-image {
  width: 350px!important;
  height: 175px!important;
  border-radius: 0!important;
}

.dz-page .dz-preview .dz-image {
  width: 350px!important;
  height: 240px!important;
}

.popover {
  max-width: 100% !important;
}

.intern-card {
  height: 100px !important;
  position: relative;
}

.intern-card,
.intern-card p,
.intern-card h1 {
  font-size: 14px !important;
  margin: 0;
  font-weight: normal;
  line-height: 1.5;
}

.intern-card:after {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 40px;
  background-image: -webkit-linear-gradient(top,rgba(255,255,255,0),#fff 100%);
  background-image: linear-gradient(-180deg,rgba(255,255,255,0),#fff 100%);
  content: '';
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.swipe-content h1 {
  font-size: 12px;
  font-weight: bold;
  color: #4A90E2;
  padding-bottom: 4px;
  border-bottom: 1px solid #4A90E2;
  margin: 12px 0 8px;
}

.list .swipe-content h1 {
  font-size: 14px;
}

.swing-wrapper .swipe-content h1 {
  font-size: 18px;
}

.swipe-content p {
  margin: 0;
  font-size: 10px;
}

.list .swipe-content p {
  font-size: 12px;
}

.swing-wrapper .swipe-content p {
  font-size: 16px;
}

.datepicker-top {
  bottom: 40px;
}

.sp-scroll {
  -webkit-overflow-scrolling : touch;
}

.cursor-pointer {
  cursor: pointer;
}

.sw-table .title {
  width: 350px;
}

.filter .dropdown-menu {
  max-height: 380px;
  overflow: auto;
}

.filter .custom-control-label::before,
.filter .custom-control-label::after {
  transform: scale(0.8);
}

@media (max-width: 480px) {
  .navbar-nav .dropdown-menu {
    width: 95vw !important;
    right: -7px !important;
    top: 70px !important;
  }

  .criteria li {
    width: 100%;
  }

  .dz-page .dz-preview .dz-image {
    width: 300px!important;
    height: 150px!important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue